module.exports = __webpack_public_path__ + "img/ring_r_s_null_0@3x.eeee1e3e.png";